import './global'


/** WEBPACK FOOTER **
 ** assets/javascripts/career.js
 **/